import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import _ from "lodash";
import { bindActionCreators } from "redux";
import * as actionCreators from "../../actions/user";

import { List, ListItem } from "material-ui/List";
import Avatar from "material-ui/Avatar";
import Badge from "material-ui/Badge";

import BookIcon from "@material-ui/icons/Book";
import IconNewApp from "material-ui/svg-icons/content/add-box";
import IconViewApps from "material-ui/svg-icons/action/assignment";
import IconMail from "material-ui/svg-icons/content/mail";
import IconLogout from "material-ui/svg-icons/action/input";
import IconOrganization from "material-ui/svg-icons/communication/business";
import SocialPerson from "material-ui/svg-icons/social/person";

import logo from "../../resources/logo/ac-logo-text.png";

import NormalFlatButton from "../../components/common/NormalFlatButton";
import InfoChip from "../../components/common/InfoChip";

import colors from "../../styles/colors";
import { colorsV2 } from "../../styles/colors";

const style = {
  container: {
    display: "flex",
    flexFlow: "column",
    minWidth: 300,
    height: "100vh",
    overflow: "hidden",
  },
  header: {
    backgroundColor: colorsV2.primary,
    minHeight: 55,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  list: {
    backgroundColor: colorsV2.primary,
    height: "100%",
    paddingTop: 42,
  },
  link: {
    textDecoration: "none",
  },
  item: {
    left: "auto",
    marginBottom: 20,
  },
  icon: {
    marginRight: 12,
    color: "white",
  },
  text: {
    display: "inline-block",
    color: "white",
    fontSize: 18,
  },
  footer: {
    position: "absolute",
    bottom: 60,
    width: 246,
    display: "flex",
    flexFlow: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  avatar: {
    margin: 5,
  },
  badge: {
    padding: "10px 5px",
  },
};

class SideNav extends Component {
  constructor(props) {
    super(props);

    this.state = {
      unreadMessageCount: this.countUnread(this.props.inbox),
      isProvider: this.props.isProvider,
    };
  }

  componentDidMount() {}

  componentWillReceiveProps(nextProps) {
    if (nextProps.inbox) {
      this.setState({
        unreadMessageCount: this.countUnread(nextProps.inbox),
      });
    }

    if (nextProps.userInfo) {
      this.setState({ isProvider: nextProps.isProvider });
    }
  }

  countUnread(inbox) {
    let unread = 0;
    try {
      inbox.forEach((item) => {
        unread = unread + item.unreadMsgCount;
      });
    } catch (error) {}
    return unread;
  }

  render() {
    if (this.props.targetDevice === "desktop") {
      return (
        <div style={style.container}>
          <div style={style.header}>
            <img src={logo} />
          </div>
          <div style={style.list}>
            <List>
              {this.state.isProvider && (
                <span className={"step_5"}>
                  <Link to="/create-app" style={style.link}>
                    <ListItem style={style.item}>
                      <IconNewApp style={style.icon} color="white" />
                      <div style={style.text}>Create New Channel</div>
                    </ListItem>
                  </Link>
                </span>
              )}
              <Link
                to={`/view-channels/${this.props.userId}`}
                style={style.link}
                className={"step_5"}
              >
                <ListItem style={style.item}>
                  <IconViewApps style={style.icon} color="white" />
                  <div style={style.text}>View My Channels</div>
                </ListItem>
              </Link>

              {this.props.user.isOrgAdmin && (
                <Link to={`/manage-org-members`} style={style.link}>
                  <ListItem style={style.item}>
                    <IconOrganization style={style.icon} color="white" />
                    <div style={style.text}>Manage Organization</div>
                  </ListItem>
                </Link>
              )}
              <Link
                to={`/message-inbox/${this.props.userId}`}
                style={style.link}
                className={"step_7"}
              >
                <ListItem style={style.item}>
                  <Badge
                    style={style.badge}
                    badgeContent={this.state.unreadMessageCount}
                    badgeStyle={{ backgroundColor: "orange", color: "black" }}
                  >
                    <IconMail style={style.icon} color="white" />
                  </Badge>
                  <div style={style.text}>Message Inbox</div>
                </ListItem>
              </Link>
              <Link
                className={"step_6"}
                to={`/external-resources/${this.props.userId}`}
                style={style.link}
              >
                <ListItem style={style.item}>
                  <BookIcon style={style.icon} />
                  <div style={style.text}>External resources</div>
                </ListItem>
              </Link>
              <Link
                to={`/profile/${this.props.userId}`}
                style={style.link}
                className={"step_8"}
              >
                <ListItem style={style.item}>
                  <SocialPerson style={style.icon} color="white" />
                  <div style={style.text}>My Profile</div>
                </ListItem>
              </Link>
            </List>
            <div style={style.footer}>
              <Avatar
                style={style.avatar}
                src={this.props.userProfile && this.props.userProfile.picture}
                size={96}
              />
              <br />
              <Link to="/" className={"step_9"}>
                <NormalFlatButton
                  icon={<IconLogout />}
                  style={{ color: "white" }}
                  label="Log Out"
                  onClick={() => this.props.userLogOut(-1)}
                />
              </Link>
            </div>
          </div>
        </div>
      );
    } //end if
    else return <div></div>;
  } //end render
}

function mapStateToProps({ user, message, messages, apps }) {
  return {
    user,
    userId: user.userId,
    userProfile: user.profile,
    userInfo: user.userInfo,
    notifications: message.notifications,
    apps,
    inbox: messages.inbox,
    isProvider:
      user.userInfo && user.userInfo.isProvider
        ? user.userInfo.isProvider
        : false,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SideNav);



// WEBPACK FOOTER //
// ./src/layout/navigation/SideNav.js